import React, { useState } from "react";
import { Button, DatePicker, Select, notification, Radio, InputNumber, Checkbox } from "antd";
import moment from "moment";
import { cloneDeep, forEach } from "lodash";

import TimingDropdown from "@components/time-dropdown";
import { dateFormatConfig } from "@utils/constants";
import { getClientName } from "@utils/helpers";
import Icon from "@assets/icon_config";
import "./reminderRecurrence.scss";
import {
  REMINDER_FORM_VIEW,
  REMINDER_FREQUENCY_VALUES,
  REMINDER_RECURRENCE_DAILY,
  REMINDER_RECURRENCE_WEEKLY,
  REMINDER_RECURRENCE_MONTHLY,
  WEEK_DAYS,
  REMINDER_RECURRENCE_END,
  REMINDER_RECURRENCE_END_BY,
  REMINDER_RECURRENCE_END_AFTER,
  REMINDER_MONTH_WEEK,
} from "../constants";

const ReminderRecurrence: any = ({ reminderData, setReminderData, setViewAction, reminderReadMode, refreshToTime, setRefreshToTime }: any) => {
  const defaultRecurrenceProperties: any = {
    type: REMINDER_RECURRENCE_DAILY,
    recurrenceCreatedDate: null,
    frequency: {
      interval: 1,
      selection: {
        weekDay: null,
        monthWeek: null,
        monthDate: null,
      },
    },
    range: {
      type: null,
      endDate: null,
      occurrence: null,
    },
  };

  const [reminder, setReminder] = useState<any>(cloneDeep(reminderData));
  const [recurrence, setRecurrence] = useState<any>(reminderData?.recurrence ? reminderData?.recurrence : defaultRecurrenceProperties);

  const onFrequencySelection = (value: any) => {
    const temp_recurrence = cloneDeep(recurrence);
    temp_recurrence.range = defaultRecurrenceProperties.range;

    temp_recurrence.type = value;
    if (value === REMINDER_RECURRENCE_MONTHLY) {
      temp_recurrence.frequency.selection.monthDate = moment(reminder?.reminderStartDate).date();
      temp_recurrence.frequency.selection.weekDay = null;
      temp_recurrence.frequency.selection.monthWeek = null;
    } else if (value === REMINDER_RECURRENCE_WEEKLY || value === REMINDER_RECURRENCE_DAILY) {
      temp_recurrence.frequency.selection = defaultRecurrenceProperties.frequency.selection;
    }
    setRecurrence(temp_recurrence);
    setReminder({
      ...cloneDeep(reminderData),
      reminderStartDate: reminderData?.reminderStartDate,
    });
  };

  const onIntervalChange = (value: any) => {
    const temp_recurrence = cloneDeep(recurrence);
    temp_recurrence.frequency.interval = value;
    temp_recurrence.range = defaultRecurrenceProperties.range;

    setRecurrence({
      ...temp_recurrence,
    });
    setReminder({
      ...cloneDeep(reminderData),
      reminderStartDate: reminderData?.reminderStartDate,
    });
  };

  const onWeekDaySelection = (value: any) => {
    const temp_recurrence = cloneDeep(recurrence);
    temp_recurrence.frequency.selection.weekDay = value;
    temp_recurrence.range = defaultRecurrenceProperties.range;

    setRecurrence({
      ...temp_recurrence,
    });
    setReminder({
      ...cloneDeep(reminderData),
      reminderStartDate: reminderData?.reminderStartDate,
    });
  };

  const onMonthDateChange = (value: any) => {
    const temp_recurrence = cloneDeep(recurrence);
    temp_recurrence.frequency.selection.monthDate = value;
    temp_recurrence.frequency.selection.weekDay = null;
    temp_recurrence.frequency.selection.monthWeek = null;
    temp_recurrence.range = defaultRecurrenceProperties.range;

    setRecurrence({
      ...temp_recurrence,
    });
    setReminder({
      ...cloneDeep(reminderData),
      reminderStartDate: reminderData?.reminderStartDate,
    });
  };

  const onMonthWeekSelection = (value: any) => {
    const temp_recurrence = cloneDeep(recurrence);
    temp_recurrence.frequency.selection.monthWeek = value;
    temp_recurrence.range = defaultRecurrenceProperties.range;

    setRecurrence({
      ...temp_recurrence,
    });
    setReminder({
      ...cloneDeep(reminderData),
      reminderStartDate: reminderData?.reminderStartDate,
    });
  };

  const getRecurrencePattern = () => {
    switch (recurrence?.type) {
      case REMINDER_RECURRENCE_DAILY:
        return (
          <div className="reminderForm__reminderContainer__recurrence__section-2__recur-selection__recurrence-pattern__value__daily">
            <Radio.Group value={recurrence?.frequency?.selection?.weekDay ? 2 : 1}>
              <Radio value={1}>
                Every&nbsp;
                <InputNumber min={1} max={31} value={recurrence?.frequency?.interval ? recurrence?.frequency?.interval : 1} onChange={(interval: any) => onIntervalChange(interval)} size="small" />
                &nbsp;day(s)
              </Radio>
              {/* <Radio value={2}>Every weekday</Radio> */}
            </Radio.Group>
          </div>
        );
      case REMINDER_RECURRENCE_WEEKLY:
        return (
          <div className="reminderForm__reminderContainer__recurrence__section-2__recur-selection__recurrence-pattern__value__weekly">
            <div className="reminderForm__reminderContainer__recurrence__section-2__recur-selection__recurrence-pattern__value__weekly__interval">
              Recur every&nbsp;
              <InputNumber min={1} max={52} value={recurrence?.frequency?.interval ? recurrence?.frequency?.interval : 1} onChange={(interval: any) => onIntervalChange(interval)} size="small" />
              &nbsp;week(s) on :
            </div>
            <div className="reminderForm__reminderContainer__recurrence__section-2__recur-selection__recurrence-pattern__value__weekly__days">
              <Checkbox.Group options={WEEK_DAYS} value={recurrence?.frequency?.selection?.weekDay} onChange={(e) => onWeekDaySelection(e)} />
            </div>
          </div>
        );
      case REMINDER_RECURRENCE_MONTHLY:
        return (
          <div className="reminderForm__reminderContainer__recurrence__section-2__recur-selection__recurrence-pattern__value__monthly">
            <Radio.Group
              onChange={(event: any) => {
                if (event.target.value === 1) {
                  onMonthDateChange(moment().date());
                } else {
                  onMonthDateChange(null);
                }
              }}
              value={recurrence?.frequency?.selection?.monthDate ? 1 : 2}
            >
              <Radio value={1}>
                Day&nbsp;
                <InputNumber
                  min={1}
                  max={moment([moment().year(), moment().month()]).daysInMonth()}
                  value={recurrence?.frequency?.selection?.monthDate}
                  onChange={(interval: any) => onMonthDateChange(interval)}
                  size="small"
                  disabled={!recurrence?.frequency?.selection?.monthDate}
                />
                &nbsp;of every&nbsp;
                <InputNumber
                  min={1}
                  max={12}
                  value={recurrence?.frequency?.selection?.monthDate ? recurrence?.frequency?.interval : null}
                  onChange={(interval: any) => onIntervalChange(interval)}
                  size="small"
                  disabled={!recurrence?.frequency?.selection?.monthDate}
                />
                &nbsp;month(s)
              </Radio>
              <Radio value={2}>
                The&nbsp;
                <Select
                  allowClear={true}
                  value={recurrence?.frequency?.selection?.monthWeek}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onChange={(e) => onMonthWeekSelection(e)}
                  disabled={recurrence?.frequency?.selection?.monthDate}
                >
                  {REMINDER_MONTH_WEEK?.map((item: any) => (
                    <Select.Option key={item.value} value={item.value} item={item}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
                &nbsp;
                <Select
                  allowClear={true}
                  value={recurrence?.frequency?.selection?.weekDay?.[0]}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onChange={(e) => onWeekDaySelection([e])}
                  disabled={recurrence?.frequency?.selection?.monthDate}
                >
                  {WEEK_DAYS?.map((item: any) => (
                    <Select.Option key={item?.value} value={item?.value} item={item}>
                      {item?.label}
                    </Select.Option>
                  ))}
                </Select>
                &nbsp;of every&nbsp;
                <InputNumber
                  min={1}
                  max={12}
                  value={!recurrence?.frequency?.selection?.monthDate ? recurrence?.frequency?.interval : null}
                  onChange={(interval: any) => onIntervalChange(interval)}
                  size="small"
                  disabled={recurrence?.frequency?.selection?.monthDate}
                />
                &nbsp;month(s)
              </Radio>
            </Radio.Group>
          </div>
        );
      default:
        return <div>not having this action view Right now</div>;
    }
  };

  const onRecurrenceConfirm = () => {
    const validation = validateRecurrence();
    if (validation?.validation) {
      setViewAction(REMINDER_FORM_VIEW);
      const temp_recurrence = cloneDeep(recurrence);
      temp_recurrence.recurrenceCreatedDate = reminder?.reminderStartDate;
      setReminderData({
        ...cloneDeep(reminder),
        recurrence: temp_recurrence,
      });
    } else {
      notification.error({
        message: "Error",
        description: validation?.message,
      });
    }
  };

  const onRecurrenceCancel = () => {
    setViewAction(REMINDER_FORM_VIEW);
    setRecurrence(reminderData.recurrence ? reminderData.recurrence : defaultRecurrenceProperties);
  };

  const getWeeklyOccurrenceStartDate = (endDate: any) => {
    const selectedDays = recurrence.frequency.selection.weekDay;
    let temp_startDate = moment(cloneDeep(reminderData?.reminderStartDate));
    let updatedReminderStartDate = moment(cloneDeep(reminderData?.reminderStartDate));

    let occurrenceCounter = 0;
    while (occurrenceCounter <= 0) {
      // eslint-disable-next-line no-loop-func
      forEach(selectedDays, (day: any, index: any) => {
        if (temp_startDate.weekday() <= day) {
          temp_startDate.weekday(day);
          occurrenceCounter += 1;
          if (occurrenceCounter === 1) {
            updatedReminderStartDate = cloneDeep(temp_startDate);
          }
        } else {
          if (selectedDays?.length - 1 === index) {
            temp_startDate.add(1, "weeks").startOf("week");
          }
        }
      });
    }
    setReminder({
      ...cloneDeep(reminder),
      reminderStartDate: moment(`${updatedReminderStartDate.format("YYYY-MM-DD")} ${moment(reminderData?.reminderStartDate)?.format("HH:mm")}`),
    });
    return updatedReminderStartDate;
  };

  const getWeeklyOccurrenceEndDate = (occurrence: any) => {
    // const temp_recurrence = cloneDeep(recurrence);
    const selectedDays: any = recurrence?.frequency?.selection?.weekDay;
    const interval = recurrence?.frequency?.interval;
    let occurrenceCounter = 0;
    let temp_startDate = moment(cloneDeep(reminderData?.reminderStartDate));
    let updatedReminderStartDate = moment(cloneDeep(reminderData?.reminderStartDate));
    while (occurrenceCounter < occurrence) {
      // eslint-disable-next-line no-loop-func
      forEach(selectedDays, (day: any) => {
        if (temp_startDate.weekday() <= day) {
          if (occurrenceCounter < occurrence) {
            temp_startDate.weekday(day);
            console.log(occurrenceCounter, temp_startDate.format("YYYY-MM-DD"), temp_startDate.date(), day, temp_startDate.date() >= day);
          }
          occurrenceCounter += 1;
          if (occurrenceCounter === 1) {
            updatedReminderStartDate = cloneDeep(temp_startDate);
          }
        }
      });
      if (occurrenceCounter < occurrence) {
        temp_startDate.add(interval, "weeks").startOf("week");
      }
    }
    setReminder({
      ...cloneDeep(reminder),
      reminderStartDate: moment(`${updatedReminderStartDate.format("YYYY-MM-DD")} ${moment(reminderData?.reminderStartDate)?.format("HH:mm")}`),
    });
    return temp_startDate;
  };

  const getMonthlyOccurrenceStartDate = (endDate: any) => {
    const selectedDate: any = recurrence?.frequency?.selection?.monthDate;
    const selectedWeek: any = recurrence?.frequency?.selection?.monthWeek;
    const selectedWeekDay: any = recurrence?.frequency?.selection?.weekDay?.[0];
    let occurrenceCounter = 0;
    let temp_startDate = moment(cloneDeep(reminderData?.reminderStartDate));
    let updatedReminderStartDate = moment(cloneDeep(reminderData?.reminderStartDate));

    if (selectedDate) {
      while (occurrenceCounter <= 0) {
        if (moment().format("YYYY-MM-DD") === temp_startDate.clone().date(selectedDate).format("YYYY-MM-DD")) {
          occurrenceCounter += 1;
        } else if (moment() > temp_startDate.clone().date(selectedDate)) {
          temp_startDate.add(1, "months").date(selectedDate);
          occurrenceCounter += 1;
        } else {
          occurrenceCounter += 1;
          if(moment([temp_startDate.clone().year(), temp_startDate.clone().month()]).daysInMonth() < selectedDate) {
            temp_startDate.date(moment([temp_startDate.clone().year(), temp_startDate.clone().month()]).daysInMonth());
          } else {
            temp_startDate.date(selectedDate);
          }
        }
        if (occurrenceCounter === 1) {
          updatedReminderStartDate = cloneDeep(temp_startDate);
        }
      }
    } else if (selectedWeek && selectedWeekDay) {
      while (occurrenceCounter <= 0) {
        temp_startDate.startOf("month");
        if (temp_startDate.day() <= selectedWeekDay) {
          temp_startDate.day(selectedWeekDay);
          temp_startDate.add((selectedWeek - 1) * 7, "days");
        } else if (temp_startDate.day() > selectedWeekDay) {
          temp_startDate.add(selectedWeek * 7, "days");
          temp_startDate.startOf("week");
          temp_startDate.day(selectedWeekDay);
        }
        if (moment(temp_startDate.format("YYYY-MM-DD")) < moment(moment().format("YYYY-MM-DD"))) {
          temp_startDate.add(1, "months");
          temp_startDate.startOf("month");
          if (temp_startDate.day() <= selectedWeekDay) {
            temp_startDate.day(selectedWeekDay);
            temp_startDate.add((selectedWeek - 1) * 7, "days");
          } else if (temp_startDate.day() > selectedWeekDay) {
            temp_startDate.add(selectedWeek * 7, "days");
            temp_startDate.startOf("week");
            temp_startDate.day(selectedWeekDay);
          }
        }
        occurrenceCounter += 1;
        if (occurrenceCounter === 1) {
          updatedReminderStartDate = cloneDeep(temp_startDate);
        }
      }
    }

    setReminder({
      ...cloneDeep(reminder),
      reminderStartDate: moment(`${updatedReminderStartDate.format("YYYY-MM-DD")} ${moment(reminderData?.reminderStartDate)?.format("HH:mm")}`),
    });
    return temp_startDate;
  };

  const getMonthlyOccurrenceEndDate = (occurrence: any) => {
    const selectedDate: any = recurrence?.frequency?.selection?.monthDate;
    const selectedWeek: any = recurrence?.frequency?.selection?.monthWeek;
    const selectedWeekDay: any = recurrence?.frequency?.selection?.weekDay?.[0];
    const interval = recurrence?.frequency?.interval;
    let occurrenceCounter = 0;
    let temp_startDate = moment(cloneDeep(reminderData?.reminderStartDate));
    let updatedReminderStartDate = moment(cloneDeep(reminderData?.reminderStartDate));

    if (selectedDate) {
      while (occurrenceCounter <= occurrence) {
        if (moment() > temp_startDate.clone().date(selectedDate)) {
          temp_startDate.add(1, "months").startOf("month");
          const date = moment([temp_startDate.clone().year(), temp_startDate.clone().month()]).daysInMonth() < selectedDate ? moment([temp_startDate.clone().year(), temp_startDate.clone().month()]).daysInMonth() : selectedDate;
          temp_startDate.date(date);
          occurrenceCounter += 1;
          if (occurrenceCounter === 1) {
            // console.log(temp_startDate.format("YYYY-MM-DD"));
            updatedReminderStartDate = cloneDeep(temp_startDate);
            // temp_startDate.add(interval, "months").date(selectedDate);
          }
        } else {
          if (occurrenceCounter < 1) {
            const date = moment([temp_startDate.clone().year(), temp_startDate.clone().month()]).daysInMonth() < selectedDate ? moment([temp_startDate.clone().year(), temp_startDate.clone().month()]).daysInMonth() : selectedDate
            temp_startDate.date(date);
            updatedReminderStartDate = cloneDeep(temp_startDate);
            occurrenceCounter += 1;
            // console.log(temp_startDate.format("YYYY-MM-DD"));
            // temp_startDate.startOf("month").add(interval, "months");
            // if(moment([temp_startDate.clone().year(), temp_startDate.clone().month()]).daysInMonth() < selectedDate) {
            //   temp_startDate.date(moment([temp_startDate.clone().year(), temp_startDate.clone().month()]).daysInMonth());
            // } else {
            //   temp_startDate.date(selectedDate);
            // }
          } else {
            occurrenceCounter += 1;
            if (occurrenceCounter <= occurrence) {
              temp_startDate.startOf("month").add(interval, "months");
              if(moment([temp_startDate.clone().year(), temp_startDate.clone().month()]).daysInMonth() < selectedDate) {
                temp_startDate.date(moment([temp_startDate.clone().year(), temp_startDate.clone().month()]).daysInMonth());
              } else {
                temp_startDate.date(selectedDate);
              }
              // console.log(temp_startDate.format("YYYY-MM-DD"), occurrenceCounter);
            }
          }
        }
      }
    } else if (selectedWeek && selectedWeekDay !== null) {
      while (occurrenceCounter < occurrence) {
        temp_startDate.startOf("month");
        if (temp_startDate.day() <= selectedWeekDay) {
          temp_startDate.day(selectedWeekDay);
          temp_startDate.add((selectedWeek - 1) * 7, "days");
        } else if (temp_startDate.day() > selectedWeekDay) {
          temp_startDate.add(selectedWeek * 7, "days");
          temp_startDate.startOf("week");
          temp_startDate.day(selectedWeekDay);
        }
        if (moment(temp_startDate.format("YYYY-MM-DD")) < moment(moment().format("YYYY-MM-DD"))) {
          temp_startDate.add(1, "months");
          temp_startDate.startOf("month");
          if (temp_startDate.day() <= selectedWeekDay) {
            temp_startDate.day(selectedWeekDay);
            temp_startDate.add((selectedWeek - 1) * 7, "days");
          } else if (temp_startDate.day() > selectedWeekDay) {
            temp_startDate.add(selectedWeek * 7, "days");
            temp_startDate.startOf("week");
            temp_startDate.day(selectedWeekDay);
          }
        }
        occurrenceCounter += 1;
        if (occurrenceCounter === 1) {
          updatedReminderStartDate = cloneDeep(temp_startDate);
          // console.log(temp_startDate.format("YYYY-MM-DD"), occurrenceCounter);
          if (occurrence > 1) {
            temp_startDate.add(interval, "months");
          }
        } else if (occurrence > 1 && occurrenceCounter < occurrence) {
          temp_startDate.add(interval, "months");
          // console.log(temp_startDate.format("YYYY-MM-DD"), occurrenceCounter);
        }
      }
    }

    setReminder({
      ...cloneDeep(reminder),
      reminderStartDate: moment(`${updatedReminderStartDate.format("YYYY-MM-DD")} ${moment(reminderData?.reminderStartDate)?.format("HH:mm")}`),
    });
    return temp_startDate;
  };

  const onRecurrenceEndTypeChange = (type: any, value: any = null, updateRecurrenceEndDate: any = true) => {
    const temp_recurrence = cloneDeep(recurrence);

    switch (type) {
      case REMINDER_RECURRENCE_END_BY:
        const endDate = value;

        temp_recurrence.range.type = type;
        temp_recurrence.range.occurrence = null;

        switch (recurrence?.type) {
          case REMINDER_RECURRENCE_DAILY:
            temp_recurrence.range.endDate = endDate ? moment(endDate).format("YYYY-MM-DD") : moment(reminder?.reminderStartDate).format("YYYY-MM-DD");
            break;

          case REMINDER_RECURRENCE_WEEKLY:
            if (updateRecurrenceEndDate) {
              temp_recurrence.range.endDate = getWeeklyOccurrenceStartDate(endDate).format("YYYY-MM-DD");
            } else {
              getWeeklyOccurrenceStartDate(endDate);
              temp_recurrence.range.endDate = endDate.format("YYYY-MM-DD");
            }
            break;
          case REMINDER_RECURRENCE_MONTHLY:
            if (updateRecurrenceEndDate) {
              temp_recurrence.range.endDate = getMonthlyOccurrenceStartDate(endDate).format("YYYY-MM-DD");
            } else {
              getMonthlyOccurrenceStartDate(endDate);
              temp_recurrence.range.endDate = endDate.format("YYYY-MM-DD");
            }
            break;
        }
        break;
      case REMINDER_RECURRENCE_END_AFTER:
        const interval = recurrence?.frequency?.interval;
        const occurrence = value ? value : 10;

        temp_recurrence.range.type = type;
        temp_recurrence.range.occurrence = value ? value : 10;

        switch (recurrence?.type) {
          case REMINDER_RECURRENCE_DAILY:
            temp_recurrence.range.endDate = moment(reminder?.reminderStartDate)
              ?.add((occurrence - 1) * interval, "days")
              .format("YYYY-MM-DD");
            break;
          case REMINDER_RECURRENCE_WEEKLY: {
            temp_recurrence.range.endDate = getWeeklyOccurrenceEndDate(occurrence).format("YYYY-MM-DD");
            break;
          }
          case REMINDER_RECURRENCE_MONTHLY: {
            temp_recurrence.range.endDate = getMonthlyOccurrenceEndDate(occurrence).format("YYYY-MM-DD");
            break;
          }
          default:
            break;
        }
    }
    setRecurrence({
      ...temp_recurrence,
    });
  };

  const validateRecurrence = () => {
    if (recurrence?.type === REMINDER_RECURRENCE_DAILY) {
      return validateRecurrenceEnd();
    } else if (recurrence?.type === REMINDER_RECURRENCE_WEEKLY) {
      if (recurrence?.frequency?.selection?.weekDay) {
        return validateRecurrenceEnd();
      } else {
        return {
          validation: false,
          message: "Please select days",
        };
      }
    } else if (recurrence?.type === REMINDER_RECURRENCE_MONTHLY) {
      if (recurrence?.frequency?.selection?.monthDate) {
        return validateRecurrenceEnd();
      } else if (recurrence?.frequency?.selection?.monthWeek && recurrence?.frequency?.selection?.weekDay) {
        return validateRecurrenceEnd();
      } else {
        return {
          validation: false,
          message: "Please select days",
        };
      }
    }
  };

  const validateRecurrenceEnd = () => {
    if (recurrence?.frequency?.interval) {
      if (recurrence?.range?.endDate || recurrence?.range?.occurrence) {
        return {
          validation: true,
          message: null,
        };
      } else {
        return {
          validation: false,
          message: "Please select reminder end",
        };
      }
    } else {
      return {
        validation: false,
        message: "Please select reminder interval",
      };
    }
  };

  const disable_end_type_based_on_empty_dependent_recurrence = () => {
    switch (recurrence?.type) {
      case REMINDER_RECURRENCE_DAILY:
        return false;
      case REMINDER_RECURRENCE_WEEKLY:
        return recurrence?.frequency?.selection?.weekDay && recurrence?.frequency?.selection?.weekDay?.length > 0 ? false : true;
      case REMINDER_RECURRENCE_MONTHLY:
        return recurrence?.frequency?.selection?.monthDate ? false : !(recurrence?.frequency?.selection?.monthWeek || recurrence?.frequency?.selection?.monthWeek);
    }
  };

  return (
    <div className="reminderForm__reminderContainer">
      <div className="reminderForm__reminderContainer__recurrence">
        <div className="reminderForm__reminderContainer__recurrence__header">
          <div className="reminderForm__reminderContainer__recurrence__header__title">{reminderData?.reminderId ? "Edit Reminder Recurrence" : "Reminder Recurrence"}</div>
          <div className="reminderForm__reminderContainer__recurrence__header__close" onClick={() => setViewAction(REMINDER_FORM_VIEW)}>
            <Icon name="close" />
          </div>
        </div>
        <div className="reminderForm__reminderContainer__body__section-1" style={{ boxShadow: "unset", marginTop: "1.6rem" }}>
          <div className="icon-clock" />
          <div className="reminderForm__reminderContainer__body__section-1__date-selector">
            <DatePicker
              value={moment(reminder?.reminderStartDate)}
              onChange={(val) => {
                setReminder({
                  ...reminder,
                  reminderStartDate: moment(`${moment(val).format("YYYY-MM-DD")} ${moment(reminderData?.reminderStartDate)?.format("HH:mm")}`),
                });
              }}
              disabledDate={(current) => current <= moment().add(-1, "days")}
              disabled={true}
              size={"middle"}
              format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
              clearIcon={false}
              // dateRender={getCalFormattedDate}
              dropdownClassName="reminderForm__reminderContainer__body__section-1__date-selector__date-picker"
              // className="ui-add-reminder__calWrap__reminderCal"
            />
          </div>
          <div className="reminderForm__reminderContainer__body__section-1__time-selector">
            <TimingDropdown
              disabled={true}
              value={reminderData?.reminderStartDate?.format("HH:mm")}
              onChange={(time: any) => {
                return true;
                // setReminder({
                //   ...reminder,
                //   reminderStartDate: moment(`${moment(reminderData?.reminderStartDate)?.format("YYYY-MM-DD")} ${time}`),
                //   reminderEndDate: moment(`${moment(reminderData?.reminderStartDate)?.format("YYYY-MM-DD")} ${moment(time, "HH:mm").add(15, "m").format("HH:mm")}`),
                // });
                // setRefreshToTime(!refreshToTime);
              }}
              timeslot={true}
              date={moment(reminderData?.reminderStartDate)?.format("YYYY-MM-DD")}
              isToDate={false}
              refreshToTime={true}
            />
            <label className="reminderForm__reminderContainer__body__section-1__time-selector__time-separator">to</label>
            <TimingDropdown
              disabled={true}
              value={reminderData?.reminderEndDate?.format("HH:mm")}
              onChange={
                (time: any) => true
                // setReminder({
                //   ...reminder,
                //   reminderEndDate: moment(`${moment(reminderData?.reminderEndDate)?.format("YYYY-MM-DD")} ${time}`),
                // })
              }
              date={moment(reminderData?.reminderEndDate)?.format("YYYY-MM-DD")}
              isToDate={true}
              refreshToTime={refreshToTime}
            />
          </div>
        </div>

        <div className="reminderForm__reminderContainer__recurrence__section-2">
          <div className="reminderForm__reminderContainer__recurrence__section-2__title">Recurrence</div>
          <div className="reminderForm__reminderContainer__recurrence__section-2__recur-selection">
            <div className="reminderForm__reminderContainer__recurrence__section-2__recur-selection__frequency">
              <div className="reminderForm__reminderContainer__recurrence__section-2__recur-selection__frequency__title">Frequency</div>
              <div className="reminderForm__reminderContainer__recurrence__section-2__recur-selection__frequency__selection">
                <Radio.Group onChange={(frequency: any) => onFrequencySelection(frequency.target.value)} value={recurrence?.type}>
                  {REMINDER_FREQUENCY_VALUES.map((item: any) => (
                    <Radio value={item?.value}>{item?.label}</Radio>
                  ))}
                </Radio.Group>
              </div>
            </div>
            <div className="reminderForm__reminderContainer__recurrence__section-2__recur-selection__recurrence-pattern">
              <div className="reminderForm__reminderContainer__recurrence__section-2__recur-selection__recurrence-pattern__title">Recurrence Pattern</div>
              <div className="reminderForm__reminderContainer__recurrence__section-2__recur-selection__recurrence-pattern__value">{getRecurrencePattern()}</div>
            </div>
          </div>
          <div className="reminderForm__reminderContainer__recurrence__section-2__recurrence-end">
            <div className="reminderForm__reminderContainer__recurrence__section-2__recurrence-end__icon">
              <div className="icon-clock" />
            </div>
            <div className="reminderForm__reminderContainer__recurrence__section-2__recurrence-end__label">Recurrence End</div>
            <div className="reminderForm__reminderContainer__recurrence__section-2__recurrence-end__drop-down">
              <Select value={recurrence?.range?.type} placeholder="End Type" onChange={(e: any) => onRecurrenceEndTypeChange(e)} disabled={disable_end_type_based_on_empty_dependent_recurrence()}>
                {REMINDER_RECURRENCE_END?.map((item: any) => (
                  <Select.Option key={item?.value} value={item?.value} item={item}>
                    {item?.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div className="reminderForm__reminderContainer__recurrence__section-2__recurrence-end__date-selector">
              {recurrence?.range?.type === REMINDER_RECURRENCE_END_BY ? (
                <DatePicker
                  value={moment(recurrence.range.endDate)}
                  onChange={(date: any) => onRecurrenceEndTypeChange(REMINDER_RECURRENCE_END_BY, date, false)}
                  disabledDate={(current) => current < moment(moment(reminder?.reminderStartDate).format("YYYY-MM-DD"))}
                  allowClear={false}
                />
              ) : recurrence?.range?.type === REMINDER_RECURRENCE_END_AFTER ? (
                <>
                  <InputNumber min={1} max={100} value={recurrence?.range?.occurrence} onChange={(interval: any) => onRecurrenceEndTypeChange(REMINDER_RECURRENCE_END_AFTER, interval)} />
                  &nbsp;occurrences
                </>
              ) : null}
            </div>
          </div>
          <div className="reminderForm__reminderContainer__recurrence__section-2__footer">
            <div className="reminderForm__reminderContainer__recurrence__section-2__footer__cancel">
              <Button style={{ height: "2.6rem", width: "7rem" }} onClick={() => onRecurrenceCancel()}>
                Cancel
              </Button>
            </div>
            <div className="reminderForm__reminderContainer__recurrence__section-2__footer__confirm">
              <Button style={{ width: "9rem", height: "2.6rem" }} type="primary" onClick={() => onRecurrenceConfirm()}>
                Confirm
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReminderRecurrence;
